<template>
  <div class="row" id="table-hover-animation">
    <div class="col-12">
      <div class="card">
        <div class="card-header">
          <h4 class="card-title">Kurslar</h4>
          <button @click="courseForm()" class="btn btn-primary waves-effect waves-light">Yangi kurs qo'shish
          </button>
        </div>
        <div class="card-content">
          <div class="card-body">
            <div class="table-responsive">
              <table class="table table-hover mb-0">
                <thead>
                <tr>
                  <th scope="col">#</th>
                  <th scope="col"><h5><b>Nomi</b></h5></th>
                  <th scope="col"><h5><b>Muallif</b></h5></th>
                  <th scope="col"><h5><b>Fan</b></h5></th>
                  <th scope="col"><h5><b>Til</b></h5></th>
                  <th class="text-center" scope="col"><h5><b>Amaliyotlar</b></h5></th>
                </tr>
                </thead>
                <transition :duration="2000" name="fade">
                  <tbody class="table-bordered"
                         v-if="loaded">
                  <tr v-bind:key="courseKey" v-for="(courseItem, courseKey) in courseList">
                    <th scope="row">{{ courseKey + 1 }}</th>
                    <td @click="courseView(courseItem.id)">
                      <img :src="`${baseURL}${courseItem.pictureSmall}`" class="mr-1"
                           height="40px">
                      <a class="btn-link">{{ courseItem.name }}</a>
                    </td>
                    <td>{{
                        courseItem.authorFullName.trim() ? courseItem.authorFullName : 'to`ldirilmagan'
                      }}
                    </td>
                    <td>{{ courseItem.subjectName }}</td>
                    <td>{{ courseItem.languageName }}</td>
                    <td class="d-flex justify-content-center">
                      <button @click="courseView(courseItem.id)"
                              class="btn waves-effect waves-light btn-icon rounded-circle btn-flat-primary"
                              title="Ko'rish">
                        <i class="feather icon-eye" style="font-size: 1.5rem"/>
                      </button>
                      <button @click="courseForm(courseItem.id)"
                              class="btn waves-effect waves-light btn-icon rounded-circle btn-flat-info"
                              title="Tahrirlash">
                        <i class="feather icon-edit" style="font-size: 1.5rem"/>
                      </button>
                      <button @click="deleteCourse(courseItem.id)"
                              class="btn waves-effect waves-light btn-icon rounded-circle btn-flat-danger"
                              title="O'chirish">
                        <i class="feather icon-trash-2" style="font-size: 1.5rem"/>
                      </button>
                    </td>
                  </tr>
                  </tbody>
                </transition>
              </table>
            </div>
          </div>
          <div class="d-flex justify-content-center" v-if="courseList.length > 0">
            <v-pagination
                :classes="bootstrapPaginationClasses"
                :page-count="totalSize"
                v-model="currentPage"/>
          </div>
        </div>
      </div>
    </div>
    <Modal :modal="modal" :modal-size="`modal-sm`" @modal-closed="modal = false">
      <deleting-modal :delete-api="deleteApi"
                      @deleted="getCourseList(currentPage - 1)"
                      v-if="modal"/>
    </Modal>
  </div>
</template>

<script>
import vPagination from 'vue-plain-pagination'
import Modal from "../../components/Modal";
import DeletingModal from "../../components/DeletingModal";

export default {
  name: "Courses",
  data() {
    return {
      courseList: [],
      deleteApi: '',
      modal: false,
      loaded: false,
      totalSize: 1,
      currentPage: 1,
      skip: null,
      bootstrapPaginationClasses: {
        ul: 'pagination',
        li: 'page-item',
        liActive: 'active',
        liDisable: 'disabled',
        button: 'page-link',
      },
    }
  },
  components: {
    DeletingModal,
    Modal,
    vPagination,
  },
  methods: {
    getCourseList(skip = 0) {
      this.loaded = false;
      this.$api.get(`admin/Course/GetAll?skip=${skip}&take=15`)
          .then(res => {
            if (!res.error) {
              this.courseList = res.result.data;
              this.totalSize = Math.ceil(res.result.total / 15);
            }
          })
          .catch(err => {
          })
          .finally(() => {
            this.loaded = true;
          })
    },

    courseView(id) {
      localStorage.removeItem('courseId');
      localStorage.setItem('courseId', id);
      this.$router.push({name: 'course', params: {id: id}})
    },

    courseForm(id = 0) {
      this.$router.push({name: 'course-form', params: {id: id}})
    },
    deleteCourse(id) {
      this.modal = true;
      this.deleteApi = `admin/Course/${id}`;
    }

  },
  watch: {
    currentPage() {
      this.getCourseList(this.currentPage - 1);
    }
  },
  created() {
    this.getCourseList();
  }
}
</script>

<style scoped>

</style>
